export class ClaimTotalsDTO {
  payInstruction: string;
  payToNationalIdNumber: string;
  payToNarrative: string;
}
